import styled from "styled-components";

export const Container = styled.form`
    background-color: #fff;
    padding: 32px 35px;
    width: 100%;
    box-sizing: border-box;
    box-shadow: 0 0 10px rgba(0, 0, 10, 0.05);

    @media (max-width: 768px) {
        padding: 16px 17.5px;
    }
`;

export const Content = styled.div`
    display: flex;
    justify-content: center;
    gap: 5rem;
    margin: 1rem 0;

    > div:nth-child(1) {
        max-width: 800px;
    }

    @media (max-width: 1100px) {
        flex-direction: column;
        align-items: center;
        gap: 4rem;

        > div:nth-child(1) {
            width: 100%;
        }
    }
`;

export const TitlePage = styled.h1`
    font-size: 24px;
    text-align: center;
    margin-bottom: 3rem;
`;

export const ContentRowInput = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin: 10px 0;

    @media (max-width: 768px) {
        width: 100%;
        flex-direction: column;
    }
`;

export const ContentInput = styled.div`
    width: 100%;
    margin: 0.4rem 0;

    input[type="file"] {
        display: none;
    }
`;

export const ContentButtonForm = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 1rem 0;
`;

export const TextFilter = styled.p`
    font-size: 16px;
`;

export const ErrorMessage = styled.p`
    color: #d32f2f;
    font-size: 12px;
    margin-bottom: 0;
    margin-top: 7px;
    margin-left: 14px;
    margin-right: 14px;
`;
